/* nl-theme.js · NextLevel24 — schlank, ohne Abhängigkeiten */
(function () {
  'use strict';
  var $ = function (s, sc) { return (sc || document).querySelector(s); };
  var $$ = function (s, sc) { return Array.prototype.slice.call((sc || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll-Reveal (nur ohne CSS-Timeline) ---------- */
  function initReveal(scope) {
    if (reduce) return;
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
    var els = $$('.nl-reveal', scope);
    if (!els.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Produktseite: Varianten, Größen-Rail, Sticky ---------- */
  function initPdp(scope) {
    var root = $('[data-nl-pdp]', scope);
    if (!root || root.dataset.nlReady === '1') return;
    root.dataset.nlReady = '1';

    var form = $('form.nl-buy', root);
    var idField = $('[data-nl-vid]', root);
    var data = null;
    try { data = JSON.parse($('#nl-variants', root) ? $('#nl-variants', root).textContent : 'null'); } catch (e) {}

    function chosen() {
      var out = [];
      $$('.nl-opt', root).forEach(function (o) {
        var on = $('.nl-sz.is-on', o);
        out.push(on ? on.getAttribute('data-nl-val') : null);
      });
      return out;
    }

    function sync() {
      if (!data) return;
      var want = chosen();
      var hit = null;
      for (var i = 0; i < data.length; i++) {
        var ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] !== null && data[i].options[j] !== want[j]) { ok = false; break; }
        }
        if (ok) { hit = data[i]; break; }
      }
      if (!hit) return;
      if (idField) idField.value = hit.id;
      var price = $('.nl-pdp__price', root);
      if (price) price.firstChild.nodeValue = hit.price_f + ' ';
      var sp = $('[data-nl-sticky-price]');
      if (sp) sp.textContent = hit.price_f;
      var cta = $('[data-nl-atc]', root);
      if (cta) {
        cta.disabled = !hit.available;
        cta.textContent = hit.available ? cta.getAttribute('data-add') || cta.textContent : cta.getAttribute('data-out') || 'Ausverkauft';
      }
      try { history.replaceState({}, '', '?variant=' + hit.id); } catch (e) {}
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('.nl-sz');
      if (b) {
        if (b.classList.contains('is-out')) return;
        var box = b.closest('.nl-opt');
        $$('.nl-sz', box).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        var val = b.getAttribute('data-nl-val');
        $$('.nl-rail__b', root).forEach(function (r) {
          r.classList.toggle('is-on', r.getAttribute('data-nl-size') === val);
        });
        sync();
        return;
      }
      var r = e.target.closest('.nl-rail__b');
      if (r && !r.classList.contains('is-out')) {
        var v = r.getAttribute('data-nl-size');
        var target = $$('.nl-sz', root).filter(function (x) { return x.getAttribute('data-nl-val') === v; })[0];
        if (target) target.click();
      }
    });

    /* Galerie: Punkte (mobil) und Miniaturen (Desktop) laufen synchron */
    var gal = $('[data-nl-gal]', root), dots = $$('.nl-pdp__dots span', root), thumbs = $$('.nl-pdp__thumb', root);
    if (gal && (dots.length || thumbs.length)) {
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (b, n) {
          var on = n === i;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }, { passive: true });
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Number(b.getAttribute('data-nl-thumb')) || 0;
          gal.scrollTo({ left: n * gal.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    }

    /* Sticky-Leiste ab 25 % Scrolltiefe */
    var bar = $('[data-nl-sticky]');
    if (bar) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.hidden = !(h > 0 && window.scrollY / h > 0.18);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var add = $('[data-nl-sticky-add]');
      if (add && form) add.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  /* ---------- Wunschliste (pro Gerät) ---------- */
  var WKEY = 'nl-wish';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wishSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function wishPaint() {
    var list = wishGet();
    $$('[data-nl-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-nl-wish')) > -1 ? 'true' : 'false');
    });
    var c = $('[data-nl-wish-count]');
    if (c) { c.textContent = list.length; c.hidden = list.length === 0; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-nl-wish]') : null;
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-nl-wish'), list = wishGet(), i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); } else { list.push(id); }
    wishSet(list); wishPaint();
    var page = $('[data-nl-wish-page]');
    if (page) initWish(page);
    var dr = $('[data-nl-wishd]');
    if (dr && !dr.hidden) wishDrawerFill();
  });

  /* ---------- Wunschlisten-Seite ----------
     Die Kacheln entstehen aus den echten Produktdaten von Shopify
     (/products/<handle>.js) — nichts wird im Browser erfunden. */
  function nlAmount(cents, thousands, decimal, dec) {
    var n = (cents / 100).toFixed(dec);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return dec ? parts.join(decimal) : parts[0];
  }
  /* Preise, die der Browser setzt, sollen genauso aussehen wie die von Shopify
     gerenderten. Deshalb wird das Waehrungsformat des Shops uebernommen
     (data-fmt), statt eigenstaendig zu formatieren. */
  function wishMoney(cents, cur, loc, fmt) {
    if (fmt && fmt.indexOf('{{') > -1) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
        switch (k) {
          case 'amount': return nlAmount(cents, ',', '.', 2);
          case 'amount_no_decimals': return nlAmount(cents, ',', '.', 0);
          case 'amount_with_comma_separator': return nlAmount(cents, '.', ',', 2);
          case 'amount_no_decimals_with_comma_separator': return nlAmount(cents, '.', ',', 0);
          case 'amount_with_apostrophe_separator': return nlAmount(cents, "'", '.', 2);
          case 'amount_with_space_separator': return nlAmount(cents, ' ', ',', 2);
          case 'amount_no_decimals_with_space_separator': return nlAmount(cents, ' ', ',', 0);
          default: return m;
        }
      });
    }
    try {
      return new Intl.NumberFormat(loc || 'de-DE', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function initWish(scope) {
    var sec = (scope && scope.hasAttribute && scope.hasAttribute('data-nl-wish-page')) ? scope : $('[data-nl-wish-page]', scope || document);
    if (!sec) return;
    var rail = $('[data-nl-wish-list]', sec);
    var empty = $('[data-nl-wish-empty]', sec);
    var list = wishGet();
    if (!rail) return;
    if (!list.length) {
      rail.hidden = true; rail.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    rail.hidden = false;
    var cur = sec.getAttribute('data-cur'), loc = sec.getAttribute('data-loc'), fmt = sec.getAttribute('data-fmt');
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(function (p) {
        var img = p.featured_image ? String(p.featured_image).split('?')[0] + '?width=600' : '';
        var out = p.available ? '' : ' nl-pcard--out';
        return '<article class="nl-card nl-pcard' + out + '">' +
          '<a class="nl-pcard__link" href="/products/' + p.handle + '"><div class="nl-pcard__pic">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="600" height="800">' : '<span class="nl-ph"></span>') +
          '</div></a>' +
          '<button type="button" class="nl-pcard__wish" data-nl-wish="' + p.handle + '" aria-pressed="true" aria-label="Von der Wunschliste nehmen">' +
          '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.4-8.6C1 9.2 2.7 5.8 6 5.1c2-.4 3.9.5 5 2.1 1.1-1.6 3-2.5 5-2.1 3.3.7 5 4.1 3.4 7.3C19.5 16.4 12 21 12 21z"/></svg>' +
          '</button>' +
          '<div class="nl-pcard__body"><a class="nl-pcard__link" href="/products/' + p.handle + '">' +
          '<p class="nl-pcard__t">' + p.title.replace(/[<>&]/g, '') + '</p></a>' +
          '<div class="nl-pcard__foot"><p class="nl-pcard__price">' + wishMoney(p.price, cur, loc, fmt) + '</p>' +
          (p.available
            ? '<a class="nl-pcard__add" href="/products/' + p.handle + '" aria-label="ansehen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></a>'
            : '<span class="nl-pcard__out">Ausverkauft</span>') +
          '</div></div></article>';
      }).join('');
      rail.innerHTML = html;
      if (!html) { rail.hidden = true; if (empty) empty.hidden = false; }
    });
  }

  /* ---------- Wunschlisten-Schublade ----------
     Gleiche Geste wie der Warenkorb: das Herz in der Kopfleiste öffnet eine
     Schublade an der Seite, statt die Seite zu wechseln. Die eigene Seite
     bleibt erreichbar — der Knopf unten in der Schublade führt dorthin. */
  function wishDrawerSet(open) {
    var d = $('[data-nl-wishd]');
    if (!d) return;
    d.hidden = !open;
    document.body.classList.toggle('nl-lock', open);
    if (open) wishDrawerFill();
  }
  function wishDrawerFill() {
    var d = $('[data-nl-wishd]');
    if (!d) return;
    var body = $('[data-nl-wishd-body]', d);
    var foot = $('[data-nl-wishd-foot]', d);
    var list = wishGet();
    var cur = d.getAttribute('data-cur'), loc = d.getAttribute('data-loc'), fmt = d.getAttribute('data-fmt');
    if (!body) return;
    if (!list.length) {
      body.innerHTML = '<div class="nl-wishd__empty"><p class="nl-sub">' +
        (d.getAttribute('data-empty') || '') + '</p><a class="nl-btn" href="' +
        (d.getAttribute('data-shop') || '/collections/all') + '">' +
        (d.getAttribute('data-shoplabel') || '') + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(function (p) {
        var img = p.featured_image ? String(p.featured_image).split('?')[0] + '?width=300' : '';
        return '<div class="nl-wi">' +
          '<a class="nl-wi__pic" href="/products/' + p.handle + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="nl-wi__in">' +
          '<p class="nl-wi__n"><a href="/products/' + p.handle + '">' + p.title.replace(/[<>&]/g, '') + '</a></p>' +
          (p.available
            ? '<p class="nl-wi__p">' + wishMoney(p.price, cur, loc, fmt) + '</p>'
            : '<p class="nl-wi__out">Ausverkauft</p>') +
          '</div>' +
          '<button type="button" class="nl-wi__x" data-nl-wish="' + p.handle + '" aria-label="Entfernen">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>' +
          '</button></div>';
      }).join('');
      body.innerHTML = html;
      if (!html) { body.innerHTML = '<div class="nl-wishd__empty"><p class="nl-sub">' + (d.getAttribute('data-empty') || '') + '</p></div>'; }
    });
  }

  /* ---------- Größenfinder ----------
     Die Empfehlung ist eine Regel, keine geschätzte Maßtabelle: übliche Größe
     plus gewünschte Passform plus der am Produkt gepflegte Passform-Hinweis. */
  function sizerSet(open) {
    var s = $('[data-nl-sizer]');
    if (!s) return;
    s.hidden = !open;
    document.body.classList.toggle('nl-lock', open);
  }
  function initSizer(scope) {
    var s = $('[data-nl-sizer]', scope) || $('[data-nl-sizer]');
    if (!s || s.dataset.nlReady === '1') return;
    s.dataset.nlReady = '1';
    var sizes = (s.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    var fit = parseInt(s.getAttribute('data-fit'), 10);
    if (isNaN(fit)) fit = 1;
    var usual = null, pref = 1;
    var rail = $('[data-nl-sizer-usual]', s);
    if (rail) {
      rail.innerHTML = sizes.map(function (x) {
        var safe = String(x).replace(/[<>&"]/g, '');
        return '<button type="button" class="nl-sizer__c" data-usual="' + safe + '">' + safe + '</button>';
      }).join('');
    }

    function calc() {
      if (usual === null) return;
      var i = sizes.indexOf(usual);
      if (i < 0) return;
      var shift = 0, why = [];
      if (pref === 2) { shift += 1; why.push('du es lässig magst'); }
      if (fit === 0) { shift += 1; why.push('das Teil klein ausfällt'); }
      if (fit === 2) { shift -= 1; why.push('das Teil groß ausfällt'); }
      var j = Math.min(sizes.length - 1, Math.max(0, i + shift));
      var res = sizes[j];
      var elS = $('[data-nl-sizer-size]', s), elW = $('[data-nl-sizer-why]', s), elO = $('[data-nl-sizer-out]', s);
      if (elS) elS.textContent = res;
      if (elW) {
        elW.textContent = (res === usual)
          ? 'Deine übliche Größe passt hier.'
          : 'Statt ' + usual + ', weil ' + why.join(' und ') + '.';
        if (i + shift > sizes.length - 1) elW.textContent += ' Größer gibt es dieses Teil nicht.';
        if (i + shift < 0) elW.textContent += ' Kleiner gibt es dieses Teil nicht.';
      }
      if (elO) elO.hidden = false;
      $$('[data-nl-sizer-rowsize]', s).forEach(function (r) {
        r.classList.toggle('is-on', r.getAttribute('data-nl-sizer-rowsize') === res);
      });
      s.dataset.result = res;
    }

    s.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var u = e.target.closest('[data-usual]');
      if (u) {
        usual = u.getAttribute('data-usual');
        $$('[data-usual]', s).forEach(function (x) { x.classList.toggle('is-on', x === u); });
        calc(); return;
      }
      var pf = e.target.closest('[data-pref]');
      if (pf) {
        pref = parseInt(pf.getAttribute('data-pref'), 10);
        $$('[data-pref]', s).forEach(function (x) { x.classList.toggle('is-on', x === pf); });
        calc(); return;
      }
      if (e.target.closest('[data-nl-sizer-take]')) {
        var want = s.dataset.result;
        var b = $$('.nl-sz').filter(function (x) {
          return x.getAttribute('data-nl-val') === want && !x.classList.contains('is-out');
        })[0];
        if (b) b.click();
        sizerSet(false);
      }
    });
  }

  /* ---------- Der ganze Look ---------- */
  function initLook(scope) {
    var sec = $('[data-nl-look]', scope) || $('[data-nl-look]');
    if (!sec || sec.dataset.nlReady === '1') return;
    sec.dataset.nlReady = '1';
    var cur = sec.getAttribute('data-cur') || 'EUR';
    var loc = sec.getAttribute('data-loc') || 'de';
    var fmt = sec.getAttribute('data-fmt');

    function priceOf(sel) {
      if (!sel) return 0;
      if (sel.tagName === 'SELECT') {
        var o = sel.options[sel.selectedIndex];
        return o ? Number(o.getAttribute('data-price')) : 0;
      }
      return Number(sel.getAttribute('data-price'));
    }
    function sum() {
      var t = 0;
      $$('[data-nl-look-i]', sec).forEach(function (row) {
        var pick = $('[data-nl-look-pick]', row), sel = $('[data-nl-look-sel]', row);
        var price = priceOf(sel);
        var p = $('[data-nl-look-p]', row);
        if (p) p.textContent = wishMoney(price, cur, loc, fmt);
        if (pick && pick.classList.contains('is-on')) t += price;
      });
      var out = $('[data-nl-look-total]', sec);
      if (out) out.textContent = wishMoney(t, cur, loc, fmt);
      var btn = $('[data-nl-look-add]', sec);
      if (btn) btn.disabled = t === 0;
    }

    sec.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var b = e.target.closest('[data-nl-look-pick]');
      if (b) {
        var on = !b.classList.contains('is-on');
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        sum(); return;
      }
      var add = e.target.closest('[data-nl-look-add]');
      if (add) {
        var items = [];
        $$('[data-nl-look-i]', sec).forEach(function (row) {
          var pick = $('[data-nl-look-pick]', row), sel = $('[data-nl-look-sel]', row);
          if (!pick || !pick.classList.contains('is-on') || !sel) return;
          var id = sel.tagName === 'SELECT' ? sel.value : sel.getAttribute('value');
          if (id) items.push({ id: Number(id), quantity: 1 });
        });
        if (!items.length) return;
        var was = add.textContent;
        add.disabled = true;
        add.textContent = add.getAttribute('data-adding') || was;
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () {
          add.textContent = add.getAttribute('data-done') || was;
          cartOpen(); cartCount();
        }).catch(function () { add.textContent = was; add.disabled = false; });
      }
    });
    sec.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-nl-look-sel]')) sum();
    });
    sum();
  }

  /* ---------- Reiter im Produktraster ---------- */
  function initTabs(scope) {
    $$('[data-nl-grid]', scope).forEach(function (sec) {
      if (sec.dataset.nlReady === '1') return;
      sec.dataset.nlReady = '1';
      var body = $('[data-nl-grid-body]', sec);
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-nl-tab]');
        if (!b || !body) return;
        $$('[data-nl-tab]', sec).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-selected', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-selected', 'true');
        var handle = b.getAttribute('data-nl-tab');
        body.style.opacity = '.45';
        fetch('/collections/' + handle + '?section_id=' + sec.id.replace('nl-grid-', ''))
          .then(function (r) { return r.text(); })
          .catch(function () { return null; })
          .then(function (html) {
            body.style.opacity = '';
            if (!html) { window.location.href = '/collections/' + handle; return; }
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var neu = tmp.querySelector('[data-nl-grid-body]');
            if (neu) { body.innerHTML = neu.innerHTML; wishPaint(); }
            else { window.location.href = '/collections/' + handle; }
          });
      });
    });
  }

  /* ---------- Filter der Kategorieseite ---------- */
  function initFilters(scope) {
    var f = $('[data-nl-filters]', scope);
    if (!f || f.dataset.nlReady === '1') return;
    f.dataset.nlReady = '1';
    f.addEventListener('change', function () { f.submit(); });
  }


  /* ---------- Kopfleiste: Zustand beim Scrollen ---------- */
  function initHeader() {
    var h = $('.nl-header');
    if (!h || h.dataset.nlReady === '1') return;
    h.dataset.nlReady = '1';
    var on = function () { h.classList.toggle('is-scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  /* ---------- Empfehlungen nachladen ----------
     `recommendations.products` ist beim normalen Seitenaufruf leer; Shopify
     füllt sie erst über die Recommendations-API. Ohne diesen Nachlader bleibt
     die Sektion "Passt dazu" unsichtbar. */
  function initReco(scope) {
    $$('[data-nl-reco]', scope).forEach(function (sec) {
      if (sec.dataset.nlRecoReady === '1') return;
      sec.dataset.nlRecoReady = '1';
      var body = $('[data-nl-cross-body]', sec);
      if (body && body.children.length) return;
      var pid = sec.getAttribute('data-nl-pid');
      var sid = sec.getAttribute('data-nl-sid');
      var lim = sec.getAttribute('data-nl-limit') || 4;
      if (!pid || !sid) return;
      fetch('/recommendations/products?section_id=' + sid + '&product_id=' + pid + '&limit=' + lim)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var neu = tmp.querySelector('[data-nl-cross-body]');
          if (neu && neu.children.length) {
            if (body) { body.innerHTML = neu.innerHTML; }
            initReveal(sec); wishPaint();
          } else { sec.hidden = true; }
        })
        .catch(function () { sec.hidden = true; });
    });
  }

  /* ---------- Warenkorb-Schublade ---------- */
  function cartFetch() {
    return fetch('/?section_id=nl-cart-body').then(function (r) { return r.text(); });
  }
  function cartPaint(html) {
    var body = $('[data-nl-drawer-body]');
    if (!body) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var inner = tmp.querySelector('[data-nl-cart-inner]');
    body.innerHTML = inner ? inner.outerHTML : html;
  }
  function cartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var b = $('[data-nl-cart-count]');
      if (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; }
    }).catch(function () {});
  }
  function cartOpen() {
    var d = $('[data-nl-drawer]');
    if (!d) return;
    d.hidden = false;
    document.body.classList.add('nl-lock');
    cartFetch().then(cartPaint).catch(function () {});
  }
  function cartClose() {
    var d = $('[data-nl-drawer]');
    if (!d) return;
    d.hidden = true;
    document.body.classList.remove('nl-lock');
  }
  function cartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function () { return cartFetch(); }).then(function (h) { cartPaint(h); cartCount(); });
  }

  /* ---------- Menü-Schublade ---------- */
  function menuSet(open) {
    var m = $('[data-nl-menu]');
    if (!m) return;
    m.hidden = !open;
    document.body.classList.toggle('nl-lock', open);
    $$('[data-nl-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      var first = m.querySelector('a, button');
      if (first) first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-nl-menu-open]')) { e.preventDefault(); menuSet(true); return; }
    if (t.closest('[data-nl-menu-close]')) { e.preventDefault(); menuSet(false); return; }
    if (t.closest('[data-nl-cart-open]')) { e.preventDefault(); cartOpen(); return; }
    if (t.closest('[data-nl-drawer-close]')) { e.preventDefault(); cartClose(); return; }
    if (t.closest('[data-nl-wish-open]')) { e.preventDefault(); wishDrawerSet(true); return; }
    if (t.closest('[data-nl-wishd-close]')) { e.preventDefault(); wishDrawerSet(false); return; }
    if (t.closest('[data-nl-sizer-open]')) { e.preventDefault(); sizerSet(true); return; }
    if (t.closest('[data-nl-sizer-close]')) { e.preventDefault(); sizerSet(false); return; }
    var q = t.closest('[data-nl-qty]');
    if (q) { e.preventDefault(); cartChange({ id: q.getAttribute('data-nl-qty'), quantity: Number(q.getAttribute('data-to')) }); return; }
    var a = t.closest('[data-nl-add]');
    if (a) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(a.getAttribute('data-nl-add')), quantity: 1 }) })
        .then(function () { return cartFetch(); }).then(function (h) { cartPaint(h); cartCount(); });
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sz = $('[data-nl-sizer]');
    if (sz && !sz.hidden) { sizerSet(false); return; }
    var wd = $('[data-nl-wishd]');
    if (wd && !wd.hidden) { wishDrawerSet(false); return; }
    var d = $('[data-nl-drawer]');
    if (d && !d.hidden) { cartClose(); return; }
    var m = $('[data-nl-menu]');
    if (m && !m.hidden) menuSet(false);
  });

  /* Kaufen ohne Seitenwechsel: Formular abfangen, Schublade öffnen */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('nl-buy')) return;
    e.preventDefault();
    var fd = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function () { cartOpen(); cartCount(); })
      .catch(function () { f.submit(); });
  });

  /* ---------- Laufband anhalten (Barrierefreiheit) ---------- */
  function initMarquee(scope) {
    $$('[data-nl-marquee-pause]', scope).forEach(function (b) {
      if (b.dataset.nlReady === '1') return;
      b.dataset.nlReady = '1';
      b.addEventListener('click', function () {
        var rail = b.parentNode.querySelector('[data-nl-marquee]');
        if (!rail) return;
        var paused = rail.classList.toggle('is-paused');
        b.firstElementChild.textContent = paused ? '▶' : 'II';
        b.setAttribute('aria-label', paused ? 'Laufband starten' : 'Laufband anhalten');
      });
    });
  }

  function init(scope) {
    var sc = scope || document;
    initReveal(sc); initPdp(sc); initTabs(sc); initFilters(sc); initMarquee(sc); initReco(sc); initHeader(); wishPaint(); initWish(sc);
    initSizer(sc); initLook(sc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
